goog.provide("shadow.js.shim.module$$mui$material$TableCell");
goog.provide("module$shadow_js_shim_module$$mui$material$TableCell");
shadow.js.shim.module$$mui$material$TableCell = shadow.js.nativeProvides["@mui/material/TableCell"] = shadow$bridge("@mui/material/TableCell");
module$shadow_js_shim_module$$mui$material$TableCell.default = shadow.js.shim.module$$mui$material$TableCell;
